import Vue from 'vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'

import Router from 'vue-router'
import store from '../store'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import Users from '../views/Users.vue'
import InactiveUsers from '../views/InactiveUsers.vue'
import WantSends from '../views/WantSends.vue'
import WantReceives from '../views/WantReceives.vue'

import WantSend from '../views/WantSend.vue'
import WantReceive from '../views/WantReceive.vue'

import User from '../views/User.vue'
import ChatGroups from '../views/ChatGroups.vue'
import Areas from '../views/Areas.vue'
import Area from '../views/Area.vue'
import Times from '../views/Times.vue'
import Time from '../views/Time.vue'

import Comments from '../views/Comments.vue'
import Comment from '../views/Comment.vue'

import Groups from '../views/Groups.vue'

import Invites from '../views/Invites.vue'
import Invite from '../views/Invite.vue'

import Skills from '../views/Skills.vue'
import Skill from '../views/Skill.vue'

import SkillCategories from '../views/SkillCategories.vue'
import PlaceCategories from '../views/PlaceCategories.vue'

import Givs from '../views/Givs.vue'
import Giv from '../views/Giv.vue'

import Events from '../views/Events.vue'
import Event from '../views/Event.vue'

import ThanksCards from '../views/ThanksCards.vue'
import ThanksCard from '../views/ThanksCard.vue'
import ThanksCardPending from '../views/ThanksCardPending.vue'

import ExportData from '../views/ExportData.vue'

import firebase from '../lib/firebase'
import api from '../lib/api'

Vue.use(Router)
Vue.use(Antd)

let user
let loading = true

const getUser = () => {
    const user = api.getCurrentUser()
    store.commit('setUser', user)
    return user
}

firebase.auth().onAuthStateChanged(async user => {
    if (user) {
        localStorage.setItem('idToken', await user.getIdToken())
        store.commit('setUser', user)
    } else {
        user = null
        store.commit('setUser', null)
        if (router.currentRoute.name !== 'login') {
            router.push({ name: 'login' })
        }
    }
    loading = false
})

const router = new Router({
    mode: 'history',
    // base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
    routes: [
        {
            path: '/login',
            name: 'login',
            component: Login,
        },
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/chat-groups',
            name: 'chat-groups',
            component: ChatGroups,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/inactive-users',
            name: 'inactive-users',
            component: InactiveUsers,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/users',
            name: 'users',
            component: Users,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/want-sends',
            name: 'want-sends',
            component: WantSends,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/want-send/:id',
            name: 'want-send',
            component: WantSend,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/want-receives',
            name: 'want-receives',
            component: WantReceives,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/want-receive/:id',
            name: 'want-receive',
            component: WantReceive,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/users/:id',
            name: 'user',
            component: User,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/groups',
            name: 'groups',
            component: Groups,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/groups/create',
            name: 'group-create',
            component: Groups,
            meta: {
                requiresAuth: true,
            },
        },

        {
            path: '/invites',
            name: 'invites',
            component: Invites,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/invites/:code',
            name: 'invite',
            component: Invite,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/comments',
            name: 'comments',
            component: Comments,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/comments/:id',
            name: 'comment',
            component: Comment,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/givs',
            name: 'givs',
            component: Givs,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/events',
            name: 'events',
            component: Events,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/events/:id',
            name: 'event',
            component: Event,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/givs/:id',
            name: 'giv',
            component: Giv,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/thanks-cards/pending',
            name: 'tc-pending',
            component: ThanksCardPending,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/thanks-cards',
            name: 'thanks-cards',
            component: ThanksCards,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/thanks-cards/:id',
            name: 'thanks-card',
            component: ThanksCard,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/areas',
            name: 'areas',
            component: Areas,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/areas/:id',
            name: 'area',
            component: Area,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/times',
            name: 'times',
            component: Times,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/times/:id',
            name: 'time',
            component: Time,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/skills',
            name: 'skills',
            component: Skills,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/skills/:id',
            name: 'skill',
            component: Skill,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/skill-categories',
            name: 'skill-categories',
            component: SkillCategories,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/place-categories',
            name: 'place-categories',
            component: PlaceCategories,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/export',
            name: 'export',
            component: ExportData,
            meta: {
                requiresAuth: true,
            },
        },
    ],
})

router.beforeResolve(async (to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        user = getUser()
        if (!user && !loading) next({ path: '/login' })
        next()
    }
    next()
})

export default router
